// extracted by mini-css-extract-plugin
export default {"common-banner":"CommonBanner_common-banner__slrdC","breadcrumb":"CommonBanner_breadcrumb__7O35V","breadcrumb-separator":"CommonBanner_breadcrumb-separator__IH5iO"};